import { FC } from 'react'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined'


export const UnsafeCard:FC = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.red[50],
        p: 2,
        borderRadius: 2,
        color: theme.palette.red[800],
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <WarningAmberOutlined sx={{ color: theme.palette.red[800], fontSize: '1.3rem' }} />
        <Typography fontWeight={theme.typography.fontWeightBold} fontSize="1rem" mb={1}>
          Danger
        </Typography>
      </Stack>

      <Typography fontWeight={theme.typography.fontWeightMedium} fontSize="0.9rem">
        Your reading seems to be unsafe
      </Typography>
    </Box>
  )
}